import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { liveRoleGuard } from '@core/guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () => import('@pages/pages.module')
      .then(m => m.PagesModule),
  },
  {
    path: 'pdf-preview/:type/:id',
    loadChildren: () => import('./core/components/pdf-preview/pdf-preview.module')
      .then(m => m.PdfPreviewModule),
    canActivate: [liveRoleGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('@pages/login/login.module')
      .then(m => m.LoginModule),
  },
  {
    path: '403',
    loadChildren: () => import('@pages/forbidden/forbidden.module')
      .then(m => m.ForbiddenModule),
  },
  {
    path: '404',
    loadChildren: () => import('@pages/not-found/not-found.module')
      .then(m => m.NotFoundModule),
  },
  {
    path: '**',
    loadChildren: () => import('@pages/not-found/not-found.module')
      .then(m => m.NotFoundModule),
  },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
